import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { Link } from "react-router-dom";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { limitParagraphByCharLimit } from "../../Helper/Helper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function HighlightPopCardDesign() {
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getFacilitiesData();
  }, []);

  const getFacilitiesData = async () => {
    const response = await SendPostRequest("facilities");
    setIsLoading(false);
    setFacilitiesData(response?.data);
  };

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Our Facilities" Image="theme-2-banner-facilities.webp" />

        <div className="container">
          <div className="row mt-5">
            <div className="offset-md-2 col-md-8">
              <div className="title-wrap text-center">
                <div className="section-title margin-bottom-60">
                  <h2 className="section-title mb-0 text-uppercase">
                    Provides Our{" "}
                    <span className="theme-color">Best Facilities</span>
                  </h2>
                  <span className="section-border-bottom center"></span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {isLoading ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <Spinner />
              </div>
            ) : facilitiesData?.length === 0 ? (
              <div
                style={{ marginBottom: "100px" }}
                className="d-flex align-items-center justify-content-center"
              >
                <h4>No Record Available</h4>
              </div>
            ) : (
              facilitiesData?.map((data, index) => (
                <div
                  key={index}
                  className="col-lg-4 mb-4 service-main-wrapper"
                >
                  <div className="service-box-wrap service-box-style-2 mb-5">
                    <div className="service-box-inner">
                      <div className="service-thumb">
                        <Link
                          to={`/facility/${data?.facility_slug
                            ?.replaceAll(" ", "-")
                            ?.replaceAll("/", "-")}`}
                        >
                          <img
                            className="img-fluid squared w-100"
                            src={
                              data?.facility_image || "/assets/images/default.jpg"
                            }
                            style={{ height: "auto" }}
                            width="100%"
                            alt={data?.facility_title}
                          />
                        </Link>
                      </div>
                      <div className="service-main-content">
                        <h3 className="mb-0 service-title">
                          <Link
                            to={`/facility/${data?.facility_slug
                              ?.replaceAll(" ", "-")
                              ?.replaceAll("/", "-")}`}
                          >
                            {data?.facility_title}
                          </Link>
                        </h3>
                        <div className="service-link">
                          <Link
                            to={`/facility/${data?.facility_slug
                              ?.replaceAll(" ", "-")
                              ?.replaceAll("/", "-")}`}
                            className="link"
                          >
                            <i className="ti-arrow-top-right"></i>
                          </Link>
                        </div>
                      </div>
                      <div className="service-overlay-content">
                        <div className="service-meta">
                          <h3 className="mb-2 service-title">
                            <Link
                              to={`/facility/${data?.facility_slug
                                ?.replaceAll(" ", "-")
                                ?.replaceAll("/", "-")}`}
                            >
                              {data?.facility_title}
                            </Link>
                          </h3>
                          <div className="service-link">
                            <Link
                              to={`/facility/${data?.facility_slug
                                ?.replaceAll(" ", "-")
                                ?.replaceAll("/", "-")}`}
                              className="link"
                            >
                              <i className="ti-arrow-top-right"></i>
                            </Link>
                          </div>
                        </div>
                        <div className="service-desc">
                          {/* <p
                            className="mb-0"
                            dangerouslySetInnerHTML={{
                              __html:
                                limitParagraphByCharLimit(data?.facility_short_description, 120) +
                                (data?.facility_short_description?.length > 120 ? "..." : ""),
                            }}
                          /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <FooterWrapper />
      </div>
    </div>
  );
}

export default HighlightPopCardDesign;
